import { createSelector } from 'reselect';

import getCartItems from './getCartItems';

const getCartProductQuantity = createSelector(
  getCartItems,
  (state, params) => params.productId,
  (cartItems, productId) => {
    const id = Number(productId);
    return cartItems.reduce(
      (sum, item) => (item.product === id ? sum + item.quantity : sum),
      0,
    );
  },
);

export default getCartProductQuantity;
